export const Colors = {
    1 : "Red",
    2 : "Yellow",
    3 : "Green",
    4 : "Black",
    Red: 1,
    Yellow: 2,
    Green: 3,
    Black: 4
};